<table class="table" *ngIf="!isLoading()">
  <thead>
    <tr>
      <th>{{ 'gamification.ranking.points.modal.action' | translate }}</th>
      <th>{{ 'gamification.ranking.points.modal.value' | translate }}</th>
      <th>{{ 'gamification.ranking.points.modal.quantity' | translate }}</th>
      <th>{{ 'gamification.ranking.points.modal.subtotal' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let action of scoreDetail()">
      <td>
        {{action.action | translate}}
        <span [attr.aria-label]="action.tooltip | translate" [opacTooltip]="action.tooltip | translate">
          <opac-icon icon="info"></opac-icon>
        </span>
      </td>
      <td>{{action.value}}</td>
      <td>{{action.amount}}</td>
      <td>{{action.subtotal}}</td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td>{{'common.total' | translate}}</td>
      <td>{{ totalScore() }}</td>
    </tr>
  </tfoot>
</table>

<app-score-skeleton *ngIf="isLoading()"></app-score-skeleton>
